module.exports = __webpack_public_path__ + "static/7_peaks-ccb7b6279f844b0e8622493679f55efa.jpg";